import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {HelperService} from "app/lib/helper.service";
import {FilterParams} from "app/models/filter_form.model";
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';
import {Router} from "@angular/router";
import {StatsRefs} from "./ref.model";
import { mergeFilterParams } from "../../lib/lib";
import { DataProvider2, DataProviderFactory, DataRequest } from "../../provider/data2.provider";
import { IStatResult } from "../../models/responce_result.model";

const unGrouped = new Map<string, boolean>([
	['Direct', true],
	['Referral', true],
	['Ungrouped', true],
]);

@Injectable()
export class RefService {
	public groupRef: DataRequest;
	
	constructor(
		private http: HttpClient,
		private helper: HelperService,
		private router: Router,
		public dpf: DataProviderFactory,
		public dp: DataProvider2,
	) {
		this.groupRef = this.dpf.getNew('group_ref');
	}

	getRefs(queryParams: FilterParams, addParams): Observable<[StatsRefs]> {
		const url: string = this.router.url.split('?')[0];
		
		return this.dp.get(
			`${url}/refs`,
			mergeFilterParams(queryParams, addParams)
		);
	}

	getRefDetails(queryParams: FilterParams): Observable<any[]> {
		return this.dp.get<IStatResult>('/reg_day/detail', queryParams)
			.pipe(map(({ stats }) => stats));
	}

	getRefStatus(): any {
		return this.dp.get('/group_ref/status');
	}
	
	isUnGrouped(group: string): boolean {
		return unGrouped.has(group);
	}
}
